<template>
    <div>
        <b-card>
            <div slot="header">
                <span class="mr-2">{{$t('CONTACTS')}}</span>
                <new-button button_type="new" variant="primary" class="pull-right" :c_permission="C_CONTACT_SAVE_BUTTON" @click="newContact" >
                   {{$t('NEW')}}
                </new-button>
            </div>
            <div class="table-responsive">
                <table class="table hover">
                <thead>
                <tr>
                    <th>{{$t('RESPONSIBLE_PERSON')}}</th>
                    <th>{{$t('EMAIL')}}</th>
                    <th>{{$t('PHONE')}}</th>
                    <th>{{$t('INSTITUTION')}}</th>
                    <th :hidden="hideItem">{{$t('EDIT')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(item,index) in items">
                    <td>{{item.responsible_person}}</td>
                    <td>{{item.email}}</td>
                    <td>{{item.phone}}</td>
                    <td>{{item.institution.name}}</td>
                    <td :hidden="hideItem"><contact-edit-button @click="edit(item)"></contact-edit-button></td>
                </tr>
                </tbody>
                </table>
            </div>
            <contact-aside :state="contactEditAsidePanelState" v-on:closeAside="contactEditAsidePanelState=false">
                <contact-edit-forme :itemEdit = itemEdit @closePanel="updatePanel($event)" @updated="contacts"></contact-edit-forme>
            </contact-aside>
        </b-card>
    </div>
</template>

<script>
import {getContactsList} from '@/services/contact/index'
import NewButton from '@/components/app/AppButton'
import ContactAside from '@/components/app/AppAside'
import ContactEditForme from '@/components/contact/ContactEditForme'
import ContactEditButton from '@/components/app/AppEdit'
import {C_CONTACT_SAVE_BUTTON} from "@/shared/component_permission"

export default {
    name:'Index',
    data() {
        return {
            items:[],
            contactEditAsidePanelState:false,
            itemEdit:null,
            C_CONTACT_SAVE_BUTTON
        }
    },
    components: {
        NewButton,
        ContactAside,
        ContactEditForme,
        ContactEditButton
    },
    methods:{
        contacts() {
            getContactsList()
            .then(response => {
                this.items = response.data
            })
        },
        newContact() {
            this.contactEditAsidePanelState = true
            this.itemEdit = null
        },
        edit(value) {
            this.itemEdit = value
            this.contactEditAsidePanelState = true
        },
        updatePanel(event) {
            this.contactEditAsidePanelState = event
            this.itemEdit = null
        }
    },
    computed: {
        user() {
          return this.$store.getters['user/getUser']
        },

    },
    created() {
        this.contacts();
    }
}
</script>
